import React, { useEffect } from 'react'
import HeroImg from '../resources/fotosKathi/24.jpg'
import Partner from '../components/Partner'
import Timeline from '../components/Timeline'
import './style/ÜberUnsPage.css'
import PeterCloseUp from '../resources/else/peterzwingler1(95von164).jpg'
import FamFoto from '../resources/famfotoszwingler(20von23).jpg'

const ÜberUnsPage = abwesend => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div className='uberUnsPage'>
      <div
        className='productPageImageDiv'
        style={{ backgroundImage: `url(${HeroImg})` }}
      >
        <div className='textDivProductPage'>
          <h1>Lerne uns kennen!</h1>
          <p>
            Willkommen bei Kaffeebrennerei – wo Leidenschaft und Qualität in
            jeder Bohne stecken!
          </p>
        </div>
      </div>
      <div className='aboutContent'>
        <div className='famSection aboutFounder'>
          <div className='famText aboutFounderText'>
            <h2>Familie Zwingler</h2>
            <p>
              Hinter jeder Bohne steckt bei uns nicht nur Handwerk, sondern auch
              Herz. Wir lieben und leben Kaffee – vom Rösten bis zum gemeinsamen
              Genießen. Zusammen führen wir unser Unternehmen mit Leidenschaft,
              Hingabe und dem festen Willen, ehrlichen Kaffee für alle zu
              schaffen.
            </p>
          </div>
          <img src={FamFoto} alt='Familie Zwingler' />
        </div>

        <div className='timeLineDiv'>
          <h2>Unsere Geschichte</h2>
          <Timeline />
        </div>

        <div className='aboutFounder'>
          <div className='aboutFounderText'>
            <h2>Ich bin Peter Zwingler – Bio-Kaffee, schonend geröstet</h2>
            <p>
              Seit der Gründung von Kaffee Zwingler im Jahr 2015 steht für mich
              eines im Mittelpunkt: Kaffee muss fair, nachhaltig und bekömmlich
              sein. Deshalb arbeite ich direkt mit Kaffeebauern zusammen, achte
              auf faire Löhne und unterstütze umweltschonende Anbaumethoden.
            </p>
            <p>
              Meine helle Röstung bewahrt die natürlichen Aromen und wertvollen
              Antioxidantien – dabei vermeide ich gezielt unerwünschte
              Bitterstoffe. Das Ergebnis: Ein Kaffee, der nicht nur großartig
              schmeckt, sondern auch gut tut.
            </p>
          </div>

          <img src={PeterCloseUp} alt='Peter Zwingler' />
        </div>
        <Partner />
      </div>
    </div>
  )
}

export default ÜberUnsPage
